import ShelfController from '../../core/shelf.controller';
import { User } from '../../data';
import dayjs from 'dayjs';

class DashboardController extends ShelfController {
    async initialize() {
        if (!this.isAuthenticated) {
            this.navigateLogin();
        } else {
            await this.loadDashboardData();
        }
    }

    retry() {
        this.setState({ loading: true, error: null }, () => this.loadDashboardData());
    }

    async loadDashboardData() {
        try {
            const today = dayjs();
            const startOfMonth = today.startOf('month').format('YYYY-MM-DD');
            const endOfMonth = today.endOf('month').format('YYYY-MM-DD');

            const currentUser = User.getInstance();
            const clientId = currentUser?.userType === 'client' ? currentUser?.client : null;

            console.log('📊 Fetching dashboard analytics from new optimized endpoint...');

            // ✅ ONE API CALL instead of 20+ client requests!
            const response = await this.data.fetchDashboardAnalytics(startOfMonth, endOfMonth, clientId);

            console.log('✅ Dashboard data received:', response);

            if (response?.success && response?.data) {
                const { data } = response;

                this.setState({
                    analytics: {
                        clients: data.clients,
                        stores: data.stores,
                        users: data.users,
                        audits: data.audits
                    },
                    recentActivity: data.recentActivity || [],
                    loading: false
                });
            } else {
                console.error('Invalid response from dashboard analytics endpoint:', response);
                this.setState({ loading: false });
            }
        } catch (error) {
            console.error('❌ Error loading dashboard data:', error);

            // Show error to user
            this.setState({
                loading: false,
                error: 'Error cargando datos del dashboard. Por favor, intente de nuevo.'
            });
        }
    }
}

export default DashboardController;
